import {
  COUNTRIES,
  PhoneInput as RawPhoneInput,
  PhoneInputProps as RawPhoneInputProps,
  SIZE,
  Country,
  mapIsoToLabel,
  PhoneInputOverrides,
} from 'baseui/phone-input';
import * as React from 'react';

import { styles } from '../styles';

export interface PhoneInputProps
  extends Omit<
    RawPhoneInputProps,
    | 'name'
    | 'disabled'
    | 'required'
    | 'country'
    | 'onCountryChange'
    | 'aria-label'
    | 'aria-labelledby'
    | 'aria-describedby'
    | 'maxDropdownHeight'
    | 'maxDropdownWidth'
    | 'overrides'
    | 'id'
    | 'error'
    | 'positive'
    | 'size'
  > {
  id?: string;
  country?: string;
  onCountryChange?: (dialCode?: string) => void;
  'aria-label'?: string | null;
  'aria-labelledby'?: string | null;
  'aria-describedby'?: string | null;
  maxDropdownHeight?: string;
  maxDropdownWidth?: string;
  mapIsoToLabel?: mapIsoToLabel | undefined;
  overrides?: PhoneInputOverrides;
  error?: boolean;
  positive?: boolean;
  size?: 'default' | 'large' | 'compact' | 'mini';
  disabled?: boolean;
  required?: boolean;
}

export default function PhoneInput(props: PhoneInputProps) {
  const {
    country,
    onCountryChange,
    size = SIZE.mini,
    overrides,
    disabled,
    ...rest
  } = props;
  const countriesList = React.useMemo(
    () => Object.keys(COUNTRIES).map((key) => ({ ...(COUNTRIES as any)[key] })),
    [],
  );
  const selectedCountry = React.useMemo(() => {
    if (country) {
      return countriesList.find((ctr) => ctr.dialCode === country);
    }
    return undefined;
  }, [countriesList, country]);

  return (
    <>
      <RawPhoneInput
        {...rest}
        disabled={disabled}
        overrides={{
          CountrySelect: {
            props: {
              overrides: {
                ControlContainer: {
                  style: {
                    borderTopLeftRadius: '6px',
                    borderTopRightRadius: '6px',
                    borderBottomLeftRadius: '6px',
                    borderBottomRightRadius: '6px',
                    ...(disabled ? styles.reset : styles.active),
                  },
                },
                Popover: {
                  props: {
                    overrides: {
                      Body: {
                        style: {
                          zIndex: 100,
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          Input: {
            props: {
              overrides: {
                Input: {
                  style: {
                    //   paddingTop: '2px',
                    //   paddingBottom: '2px',
                    ...(disabled ? styles.reset : styles.active),
                  },
                },
                Root: {
                  style: {
                    borderTopLeftRadius: '6px',
                    borderTopRightRadius: '6px',
                    borderBottomLeftRadius: '6px',
                    borderBottomRightRadius: '6px',
                    ...(disabled ? styles.reset : styles.active),
                  },
                },
                InputContainer: {
                  style: { ...(disabled ? styles.reset : styles.active) },
                },
              },
            },
          },

          ...overrides,
        }}
        country={selectedCountry}
        onCountryChange={({ option }) =>
          onCountryChange?.((option as Country).dialCode)
        }
        size={size}
      />
    </>
  );
}
